import djmtDjbtUnknownImage from "../assets/djmt-djbt-unknown.svg";
import djmtDjbtClosedOnImage from "../assets/djmt-djbt-closed-on.svg";
import djmtDjbtOpenOffImage from "../assets/djmt-djbt-open-off.svg";
import djmtDjbtNotelemetryImage from "../assets/djmt-djbt-notelemetry.svg";

type BreakerImageProps = {
    type: "on" | "off" | "notelemetry" | "unknown";
    width?: string | number;
    height?: string | number;
}

export function BreakerImage({ type, width, height }: BreakerImageProps) {
    const getBreakerImage = () => {
        switch (type) {
            case "on":
                return {
                    src: djmtDjbtClosedOnImage,
                    alt: "disjuntor fechado"
                }
            case "off":
                return {
                    src: djmtDjbtOpenOffImage,
                    alt: "disjuntor aberto"
                }
            case "notelemetry":
                return {
                    src: djmtDjbtNotelemetryImage,
                    alt: "disjuntor sem telemetria"
                }
            default:
                return {
                    src: djmtDjbtUnknownImage,
                    alt: "disjuntor com status desconhecido"
                }
        }
    }

    const breakerImage = getBreakerImage();

    return (
        <img
            width={width}
            height={height}
            src={breakerImage.src}
            // className="rounded"
            alt={breakerImage.alt}
        />
    );
}